// Copy-to-clipboard for the scoped subscribe cards on sector/union/org pages,
// where the feed URL is fixed server-side and there is no filter UI.
(function () {
    'use strict';

    document.addEventListener('click', function (evt) {
        const btn = evt.target.closest ? evt.target.closest('[data-copy-url]') : null;
        if (!btn) return;

        const url = btn.getAttribute('data-copy-url');
        const label = btn.querySelector('[data-copy-label]');
        if (!navigator.clipboard || !navigator.clipboard.writeText) return;

        navigator.clipboard.writeText(url).then(function () {
            if (!label) return;
            const original = label.textContent;
            label.textContent = 'Copied';
            window.setTimeout(function () { label.textContent = original; }, 2000);
        });
    });
})();

(function () {
    'use strict';

    const elFeedUrl = document.getElementById('ical-feed');
    if (!elFeedUrl) return;

    const elSubscribe = document.getElementById('ical-subscribe');
    const elGoogle = document.getElementById('ical-google');
    const elCopy = document.getElementById('ical-copy');

    const selectorCb = 'data-ical-cb';
    const checkboxes = Array.prototype.slice.call(document.querySelectorAll('[' + selectorCb + ']'));
    if (!checkboxes.length) return;

    const baseFeed = 'https://www.strikecalendar.co.uk/ical';

    // Derived from the rendered checkboxes, which are themselves generated from the
    // StrikeType enum. Hard-coding this list is what let "tube" go missing and let
    // "emergency" ship as a filter value the server could never parse.
    const cbState = {};
    checkboxes.forEach(function (cb) {
        cbState[cb.getAttribute(selectorCb)] = cb.checked;
    });

    function currentUrl() {
        if (cbState['all']) return baseFeed;

        const filters = Object.keys(cbState)
            .filter(function (key) { return key !== 'all' && cbState[key]; })
            .map(function (key) { return 'filters=' + encodeURIComponent(key); });

        return filters.length ? baseFeed + '?' + filters.join('&') : baseFeed;
    }

    function updateTargets() {
        const url = currentUrl();
        const webcal = url.replace(/^https?:/, 'webcal:');

        elFeedUrl.value = url;
        if (elSubscribe) elSubscribe.href = webcal;
        if (elGoogle) elGoogle.href = 'https://calendar.google.com/calendar/r?cid=' + encodeURIComponent(webcal);
    }

    function updateUI(cb, checked) {
        if (cb === 'all' && checked) {
            Object.keys(cbState).forEach(function (key) { cbState[key] = false; });
            cbState['all'] = true;
        } else {
            cbState[cb] = checked;
            if (cb !== 'all' && checked) cbState['all'] = false;
            // Unticking the last sector would otherwise leave nothing selected, which
            // silently serves the unfiltered feed. Fall back to "All" explicitly.
            const anySector = Object.keys(cbState).some(function (key) { return key !== 'all' && cbState[key]; });
            if (!anySector) cbState['all'] = true;
        }

        checkboxes.forEach(function (el) {
            el.checked = !!cbState[el.getAttribute(selectorCb)];
        });

        updateTargets();
    }

    checkboxes.forEach(function (el) {
        el.addEventListener('change', function (evt) {
            updateUI(evt.target.getAttribute(selectorCb), evt.target.checked);
        });
    });

    if (elCopy) {
        const label = elCopy.querySelector('[data-copy-label]');
        const original = label ? label.textContent : '';

        elCopy.addEventListener('click', function () {
            const url = currentUrl();

            function done() {
                if (!label) return;
                label.textContent = 'Copied';
                window.setTimeout(function () { label.textContent = original; }, 2000);
            }

            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(url).then(done, function () {
                    elFeedUrl.focus();
                    elFeedUrl.select();
                });
            } else {
                // Older Safari / non-secure contexts have no clipboard API.
                elFeedUrl.focus();
                elFeedUrl.select();
            }
        });
    }

    updateTargets();
})();
